import { render, staticRenderFns } from "./onetimeUpload.vue?vue&type=template&id=bc179c1a&scoped=true"
import script from "./onetimeUpload.vue?vue&type=script&lang=js"
export * from "./onetimeUpload.vue?vue&type=script&lang=js"
import style0 from "./onetimeUpload.vue?vue&type=style&index=0&id=bc179c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc179c1a",
  null
  
)

export default component.exports